import Component from '../core/Component'
import $ from 'jquery'
import NetteForms from '../nette/NetteForms'
import { queryAll } from '../utils/dom'
import EventBus from '../core/EventBus'
import { logElement, logVisit } from './VisitLog'

export const SELECTOR = '[data-rel="news-modal"], [data-rel="job-modal"]'
export const CONTROL_SELECTOR = '[data-ref="modalNext"], [data-ref="modalPrevious"]'

export default class Page extends Component {
    constructor(element) {
        super(element)

        this.isOpen = false
        this.currentModal = null
        this.popStateClose = false

        this.handleControlClick = this.handleControlClick
        this.handleModalOpen = this.handleModalOpen
        this.handleModalClose = this.handleModalClose
        this.handlePopState = this.handlePopState

        this.request = null
    }

    prepare() {
        this.element.addEventListener('click', this.handleClick)
        window.addEventListener('popstate', this.handlePopState)
    }

    destroy() {
        document.removeEventListener('click', this.handleControlClick)
        window.removeEventListener('popstate', this.handlePopState)
    }

    fetchContent(trigger) {
        if (this.request) {
            this.request.abort()
        }

        this.request = $.ajax({
            url: trigger.href,
            dataType: 'HTML',
            success: (response) => {
                const buffer = document.createElement('div')
                buffer.innerHTML = response
                const content = buffer.querySelector('[data-rel="content"]')
                this.openModal({
                    content: content.outerHTML,
                    type: trigger.dataset.rel,
                    url: trigger.href,
                })
            },
        })
    }

    openModal({ content, type, url }) {
        const modal = Component.getFromElement(type)

        if (modal) {
            this.currentModal = modal
            modal.on({
                open: this.handleModalOpen,
                close: this.handleModalClose,
            })
            modal.setContent(content)

            const forms = queryAll('form', modal.element)
            forms.forEach((form) => NetteForms.initForm(form))
            $.nette.load()

            if (this.isOpen) {
                history.replaceState(null, null, url)
            } else {
                history.pushState(null, null, url)
            }

            modal.open()
        }
    }

    handleClick = (event) => {
        if (!event.target.closest) {
            // Polyfill doesn't apply for svg elements, skip in IE
            return
        }

        const target = event.target.closest(SELECTOR)

        if (target) {
            event.preventDefault()
            this.fetchContent(target)
            logElement(target)
        }
    }

    handlePopState = (event) => {
        if (this.currentModal) {
            this.currentModal.close()
        }
    }

    handleModalOpen = () => {
        if (!this.isOpen) {
            document.addEventListener('click', this.handleControlClick)
            this.isOpen = true
        }
    }

    handleModalClose = () => {
        this.currentModal = null
        if (!this.isOpen) {
            return
        }
        this.isOpen = false
        EventBus.emit('swup:custom:block')
        history.back()
        document.removeEventListener('click', this.handleControlClick)
    }

    handleControlClick = (event) => {
        const trigger = event.target.closest(CONTROL_SELECTOR)

        if (trigger) {
            event.preventDefault()
            this.fetchContent(trigger)
        }
    }
}
